
import React from 'react';
import { AppSidebar } from '@/components/AppSidebar';
import { useIsMobile } from '@/hooks/use-mobile';
import { MobileBottomNav } from '@/components/mobile/MobileBottomNav';
import { MobileHeader } from '@/components/mobile/MobileHeader';
import { PullToRefresh } from '@/components/mobile/PullToRefresh';
import { useLocation } from 'react-router-dom';
import { OfflineInitializer } from '@/components/offline/OfflineInitializer';
import { useSyncStatus } from '@/contexts/offline';
import { usePermissions } from '@/contexts/unified-permissions';
import { getHeaderProps } from '@/utils/headerUtils';

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const { performSync } = useSyncStatus();
  const { forceRefreshPermissions } = usePermissions();

  const headerProps = getHeaderProps(location.pathname);

  const handlePullToRefresh = async () => {
    console.log('🔄 Pull to refresh: Starting pull-to-refresh action');
    try {
      // Perform data sync
      console.log('🔄 Pull to refresh: Performing data sync');
      await performSync();
      console.log('✅ Pull to refresh: Data sync completed');

      // Also refresh permissions/subscription status to catch any upgrades
      console.log('🔄 Pull to refresh: Starting permissions force refresh');
      await forceRefreshPermissions();
      console.log('✅ Pull to refresh: Permissions force refresh completed');
    } catch (error) {
      console.error('❌ Pull to refresh failed:', error);
    }
  };

  if (isMobile) {
    return (
      <OfflineInitializer>
        <div className="flex flex-col min-h-screen bg-background"
       style={{ paddingLeft: 'env(safe-area-inset-left)',
                paddingRight: 'env(safe-area-inset-right)' }}>
    <MobileHeader {...headerProps} />

    <PullToRefresh
      onRefresh={handlePullToRefresh}
      className="flex-1"
    >
      <main className="min-h-full overflow-y-auto"
            style={{
              paddingTop: 'calc(3.5rem + env(safe-area-inset-top))',
              paddingBottom: 'calc(4rem + env(safe-area-inset-bottom))'
            }}>
        <div className="space-y-4 px-4">{children}</div>
      </main>
    </PullToRefresh>

    <MobileBottomNav />
  </div>
      </OfflineInitializer>
    );
  }

  // Desktop fallback
  return (
    <OfflineInitializer>
      <div className="flex w-full bg-background h-full">
        <AppSidebar />
        <main className="flex-1 ml-64 px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8">
          <div className="space-y-4 sm:space-y-6 max-w-7xl mx-auto">
          {children}
        </div>
        </main>
      </div>
    </OfflineInitializer>
  );
};


